module.exports = {
	"art": "Art",
	"ant": "Antiquités",
	"col": "Objets de collection",
	"tec": "Informatique et électronique",
	"jgw": "Bijoux, pierres précieuses et montres",
	"cai": "Commercial et industriel",
	"bac": "Donation et charité",
	"eab": "Chevaux et bétail",
	"fhi": "Meubles et articles ménagers",
	"veh": "Véhicules",
	"hvy": "Équipements lourds",
	"fme": "Machines agricoles",
	"rei": "Immobilier",
	"gov": "Gouvernement",
	"undefined": "Aucune catégorie"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/categories.json5
// module id = 1973
// module chunks = 6